import { render, staticRenderFns } from "./DepartureTabsNotes.vue?vue&type=template&id=0ab3b11b&scoped=true&"
import script from "./DepartureTabsNotes.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab3b11b",
  null
  
)

export default component.exports